export interface Page {
  normalized_rank?: number;
  id: number;
  name: string;
  type: PageType;
  block_id: number;
  rank: number;
}

export enum PageType {
  ELEMENT_PAGE_MODEL = 'ElementPageModel',
  LOGIC_PAGE_MODEL = 'LogicPageModel',
}
